var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17188 22.9492C0.996094 23.2422 0.9375 23.5938 0.9375 23.9453C0.9375 25.0586 1.81641 25.9375 2.92969 25.9375H27.0117C28.125 25.9375 29.0625 25.0586 29.0625 23.9453C29.0625 23.5938 28.9453 23.2422 28.7695 22.9492L16.9922 2.73438C16.582 2.03125 15.8203 1.5625 15 1.5625C14.1211 1.5625 13.3594 2.03125 12.9492 2.73438L1.17188 22.9492ZM0.351562 22.4805L12.1289 2.26562C12.7148 1.26953 13.8281 0.625 15 0.625C16.1133 0.625 17.2266 1.26953 17.8125 2.26562L29.5898 22.4805C29.8242 22.8906 30 23.418 30 23.9453C30 25.5859 28.6523 26.875 27.0117 26.875H2.92969C1.28906 26.875 0 25.5859 0 23.9453C0 23.418 0.117188 22.8906 0.351562 22.4805ZM15 8.125C15.2344 8.125 15.4688 8.35938 15.4688 8.59375V17.9688C15.4688 18.2617 15.2344 18.4375 15 18.4375C14.707 18.4375 14.5312 18.2617 14.5312 17.9688V8.59375C14.5312 8.35938 14.707 8.125 15 8.125ZM14.0625 21.25C14.0625 20.7812 14.4727 20.3125 15 20.3125C15.4688 20.3125 15.9375 20.7812 15.9375 21.25C15.9375 21.7773 15.4688 22.1875 15 22.1875C14.4727 22.1875 14.0625 21.7773 14.0625 21.25Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCritical);
export default __webpack_public_path__ + "static/media/icon_critical.da171a2610e794c1d9a30f18ad77e7ee.svg";
export { ForwardRef as ReactComponent };